<h3>Appréciation des camarades</h3>

@for (groupId of otherGroups(); track groupId) {
    <div>
        <h4>{{groupId}}</h4>
        {{ratingOthers()[groupId] | json}}
    </div>
}